import React from 'react';
import PropTypes from 'prop-types';

const getPopularityColor = (popularity) => {
  if (popularity < 30) return 'from-green-300 to-green-500';
  if (popularity < 70) return 'from-honey-300 to-honey-600';
  return 'from-red-300 to-red-500';
};

const getPopularityDot = (popularity) => {
  if (popularity < 30) return 'bg-green-400';
  if (popularity < 70) return 'bg-honey-500';
  return 'bg-red-400';
};

const getPopularityText = (popularity) => {
  if (popularity < 30) return 'Not busy';
  if (popularity < 70) return 'Moderately busy';
  return 'Very busy';
};

const OccupancyIndicator = ({ popularity }) => {
  if (popularity === null || popularity === undefined) {
    return (
      <div className="mt-3 flex items-center gap-2 text-xs text-gray-400 dark:text-gray-500">
        <div className="w-1.5 h-1.5 rounded-full bg-gray-300 dark:bg-gray-600" />
        <span>Occupancy data not available</span>
      </div>
    );
  }

  const status = getPopularityText(popularity);

  return (
    <div className="mt-3" role="region" aria-label="Current occupancy">
      <div className="flex justify-between items-center text-xs mb-1.5">
        <span className="flex items-center gap-1.5 text-gray-500 dark:text-gray-400">
          <div className={`w-1.5 h-1.5 rounded-full ${getPopularityDot(popularity)}`} />
          {status}
        </span>
        <span className="font-semibold text-gray-600 dark:text-gray-300">{popularity}%</span>
      </div>
      <div className="h-1.5 bg-gray-100 dark:bg-gray-700 rounded-full overflow-hidden">
        <div
          className={`h-full rounded-full bg-gradient-to-r ${getPopularityColor(popularity)} animate-progress-fill transition-all`}
          style={{ width: `${popularity}%` }}
          role="progressbar"
          aria-valuenow={popularity}
          aria-valuemin="0"
          aria-valuemax="100"
          aria-label={`${popularity}% occupancy - ${status}`}
        />
      </div>
    </div>
  );
};

OccupancyIndicator.propTypes = {
  popularity: PropTypes.number,
};

export default OccupancyIndicator;
